// Dayjs doesn't manage ISO duration (even it "duration" plugin won't work here)
import { formatISODuration } from 'date-fns'
import dayjs from 'dayjs'

import React, { useEffect, useState } from 'react'

import TimerLabel from './TimerLabel'
import type { SaleProps } from '../../shared/Module'

const URL_LABELS = {
  flash_sales: 'de la vente flash',
  private_sales: 'de la vente privée',
  soldes: 'soldés',
}

const TITLES = {
  flash_sales: 'Vente flash',
  private_sales: 'Vente privée',
  soldes: 'Soldes',
}

const SaleCountdown = ({
  endsAt: initialEndsAt,
  startsAt: initialStartsAt,
  url,
  kind,
  title,
  description,
  displayTitle,
}: SaleProps) => {
  const startsAt = new Date(initialStartsAt)
  const endsAt = new Date(initialEndsAt)

  const calculateTimeLeft = () => {
    const now = new Date()
    const alreadyStarted = dayjs(startsAt).diff(dayjs(now), 'second') < 0
    const refDate = alreadyStarted ? endsAt : startsAt
    const diff = dayjs(refDate).diff(dayjs(now), 'second')
    const timeLeft: any = {}

    if (diff > 0) {
      timeLeft.days = Math.floor(diff / (60 * 60 * 24))
      timeLeft.hours = Math.floor((diff / (60 * 60)) % 24)
      timeLeft.minutes = Math.floor((diff / 60) % 60)
      timeLeft.seconds = Math.floor(diff % 60)
      // Use `timeLeft` date properties that were just set
      timeLeft.duration = formatISODuration(timeLeft)
      timeLeft.label = alreadyStarted ? 'Fin dans' : 'Début dans'
    } else {
      timeLeft.label = 'Vente terminée !'
    }

    return timeLeft
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)
  })

  return (
    <div
      className={`${displayTitle ? 'c-flash-sale--large' : ''} c-flash-sale`}
    >
      {displayTitle && title ? (
        <>
          <h2>{title}</h2>
          {description && (
            <div dangerouslySetInnerHTML={{ __html: description }} />
          )}
        </>
      ) : (
        <span className='visually-hidden'>{title || TITLES[kind]}</span>
      )}
      <div className='c-flash-sale__text'>
        <span className='c-flash-sale__ending'>{timeLeft.label}</span>
        <time className='c-flash-sale__countdown' dateTime={timeLeft.duration}>
          <TimerLabel {...timeLeft} />
        </time>
      </div>
      {url && (
        <a href={url} className='c-flash-sale__link mlc-btn mlc-btn-type-1'>
          Tous les produits <span>{URL_LABELS[kind]}</span>
        </a>
      )}
    </div>
  )
}

export default SaleCountdown
